import { action, makeAutoObservable } from 'mobx';
import { HallMaintenanceTask } from '../domain/HallMaintenanceTask';
import { HallMaintenanceTaskAssignment } from '../domain/HallMaintenanceTaskAssignment';
import { RootStore } from './RootStore';
import { ServerStore } from './ServerStore';

export class HallMaintenanceStore {
    rootStore: RootStore;
    serverStore: ServerStore;
    tasks: HallMaintenanceTask[] = [];
    assignmentsByTask: Record<number, HallMaintenanceTaskAssignment[]> = {};

    constructor(rootStore: RootStore, serverStore: ServerStore) {
        this.rootStore = rootStore;
        this.serverStore = serverStore;
        makeAutoObservable(this);
    }

    getTasks = () => {
        this.serverStore.get('/hall-maintenance', action((data) => {
            this.tasks = data;
        }));
    }

    createTask = (task: Partial<HallMaintenanceTask>, onSuccess?: () => void) => {
        this.serverStore.post('/hall-maintenance', task, () => {
            this.rootStore.notificationsStore.add('hall_maintenance_task_is_saved', "success");
            this.getTasks();
            onSuccess && onSuccess();
        });
    }

    updateTask = (id: number, task: Partial<HallMaintenanceTask>, onSuccess?: () => void) => {
        this.serverStore.patch(`/hall-maintenance/${id}`, task, () => {
            this.rootStore.notificationsStore.add('hall_maintenance_task_is_updated', "success");
            this.getTasks();
            onSuccess && onSuccess();
        });
    }

    deleteTask = (id: number, onSuccess?: () => void) => {
        this.serverStore.delete(`/hall-maintenance/${id}`, () => {
            this.rootStore.notificationsStore.add('hall_maintenance_task_is_deleted', "success");
            this.getTasks();
            onSuccess && onSuccess();
        });
    }

    getAssignments = (taskId: number, onSuccess?: () => void) => {
        this.serverStore.get(`/hall-maintenance/tasks/${taskId}/assignments`, action((data) => {
            this.assignmentsByTask[taskId] = data;
            onSuccess && onSuccess();
        }));
    }

    createAssignment = (assignment: Partial<HallMaintenanceTaskAssignment>, onSuccess?: () => void) => {
        this.serverStore.post('/hall-maintenance/assignments', assignment, action((data: HallMaintenanceTaskAssignment) => {
            const taskId = assignment.taskId!;
            const existing = this.assignmentsByTask[taskId] || [];
            this.assignmentsByTask[taskId] = [data, ...existing];
            this.rootStore.notificationsStore.add('hall_maintenance_assignment_is_saved', "success");
            onSuccess && onSuccess();
        }));
    }

    updateAssignment = (id: number, taskId: number, assignment: Partial<HallMaintenanceTaskAssignment>, onSuccess?: () => void) => {
        this.serverStore.patch(`/hall-maintenance/assignments/${id}`, assignment, action((data: HallMaintenanceTaskAssignment) => {
            const existing = this.assignmentsByTask[taskId] || [];
            this.assignmentsByTask[taskId] = existing.map(item => item.id === id ? data : item);
            this.rootStore.notificationsStore.add('hall_maintenance_assignment_is_updated', "success");
            onSuccess && onSuccess();
        }));
    }

    deleteAssignment = (id: number, taskId: number, onSuccess?: () => void) => {
        this.serverStore.delete(`/hall-maintenance/assignments/${id}`, action(() => {
            const existing = this.assignmentsByTask[taskId] || [];
            this.assignmentsByTask[taskId] = existing.filter(item => item.id !== id);
            this.rootStore.notificationsStore.add('hall_maintenance_assignment_is_deleted', "success");
            onSuccess && onSuccess();
        }));
    }
}
